import { makeStyles, Typography, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import { Stack } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  tabStyled: {
    border: "1px solid #B6B3B3",
    borderRadius: "10px",
    height: theme.spacing(13),
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: 0,
    "@media only screen and (max-width: 600px)": {
      justifyContent: "space-between",
      height: theme.spacing(9),
      padding: 10,
    },
  },
  disabledTab: {
    pointerEvents: "none",
    opacity: 0.5,
  },
}));

function TabContainer({ tabs }) {
  const router = useRouter();
  const [activeTab, setActiveTab] = useState();

  useEffect(() => {
    if (router.query.tab) {
      setActiveTab(
        `/payment-methods/${router.query.id}/${router.query.slug}?tab=${router.query.tab}`
      );
    } else {
      setActiveTab(
        `/payment-methods/${router.query.id}/${router.query.slug}?tab=rial`
      );
    }
  }, [router.query.tab]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const classes = useStyles();

  return (
    <div>
      <nav>
        <ul className={classes.tabStyled}>
          {tabs.map((tab, index) => (
            <li
              key={index}
              // className={activeTab === tab.path ? "active" : ""}
              style={{
                cursor: tab.disabled ? "not-allowed" : "pointer",
                padding: isMobile ? 0 : "15px",
                display: "inline",
                fontFamily: "vazir-bold",
                borderBottom:
                  activeTab === tab.path ? "2px solid blue" : "none",
              }}
              className={tab.disabled ? classes.disabledTab : ""}
            >
              <Link href={tab.path}>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  flexDirection={"column"}
                  color={activeTab === tab.path ? "#0A369D" : "#292929"}
                  onClick={() => !tab.disabled && setActiveTab(tab.path)}
                  height={"100%"}
                  width={"100%"}
                >
                  <Stack
                    height={"50px"}
                    width={"100%"}
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    {tab.icon}
                  </Stack>
                  <a
                    style={{
                      fontSize: isMobile ? "14px" : "18px",
                    }}
                  >
                    {tab.label}
                  </a>
                </Stack>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div>
        {tabs.map((tab, index) => (
          <div
            key={index}
            style={{ display: activeTab === tab.path ? "block" : "none" }}
          >
            {activeTab === tab.path && tab.component()}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TabContainer;
